import { Link } from '@tanstack/react-router'

export type QuickActionButtonProps = {
  icon: string
  label: string
  className?: string
  testId?: string
} & ({ to: string; onClick?: never } | { onClick: () => void; to?: never })

const BASE_CLASS =
  'flex min-w-0 w-full h-full aspect-square cursor-pointer flex-col items-center justify-center gap-2 overflow-clip rounded-lg border border-indigo-100 bg-white p-2 transition-colors hover:bg-indigo-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-800 active:bg-indigo-100'

export function QuickActionButton({
  icon,
  label,
  className = '',
  testId,
  ...action
}: QuickActionButtonProps) {
  const classes = `${BASE_CLASS} ${className}`
  const content = (
    <>
      <img src={icon} alt="" aria-hidden className="size-10 shrink-0" />
      <span className="text-center text-sm leading-4.5 text-balance text-neutral-900">
        {label}
      </span>
    </>
  )

  return action.to ? (
    <Link to={action.to} className={classes} data-testid={testId}>
      {content}
    </Link>
  ) : (
    <button
      type="button"
      onClick={action.onClick}
      className={classes}
      data-testid={testId}
    >
      {content}
    </button>
  )
}
